import { render, staticRenderFns } from "./DrawnNumbers.vue?vue&type=template&id=31245fdf&scoped=true"
import script from "./DrawnNumbers.vue?vue&type=script&lang=js"
export * from "./DrawnNumbers.vue?vue&type=script&lang=js"
import style0 from "./DrawnNumbers.vue?vue&type=style&index=0&id=31245fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31245fdf",
  null
  
)

export default component.exports